import React, { useEffect, useMemo, useState } from "react";
import { getOAuthData } from "../../network/getOAuthData";

const OAuth = ({ component, altSrc = '' }) => {
    const finalAltSrc = altSrc ? altSrc : require("../../../assets/images/no-image.png");
    const [finalUri, setFinalUri] = useState(finalAltSrc);
    const mediaUrl = component?.props?.src ?? component?.props.url;

    useEffect(() => {
        const getAuthUri = async () => {
            if (!mediaUrl) {
                setFinalUri(altSrc);
                return;
            }
            const data = await getOAuthData(mediaUrl);
            if (data) setFinalUri(data);
            else setFinalUri(finalAltSrc);
        }
        getAuthUri();
    }, [mediaUrl]);

    if (!component || !React.isValidElement(component)) {
        console.info("Passed component is not valid component.");
        return component;
    }

    // if (!finalUri) return null;

    // Modify the value of Authorization header if props exist
    const modifiedProps = { ...((component).props) };
    modifiedProps.src = finalUri;
    modifiedProps.url = finalUri;
    const AUTH_SAFE_COMP = React.cloneElement(component, modifiedProps);

    return (
        <React.Fragment key={finalUri}>
            {AUTH_SAFE_COMP}
        </React.Fragment>
    )
}

export default OAuth;